import { Stack } from '@mui/material'
import Typography from '@mui/material/Typography'
import { MeetsFilter } from '../../../components/MeetsFilter/MeetsFilter'
import { Records } from '../../../components/Records/Records'
import { BlockWrapper } from '../../../components/Wrapper/BlockWrapper'
import { HeaderWrapper } from '../../../components/Wrapper/HeaderWrapper'
import { TitleWrapper } from '../../../components/Wrapper/TitleWrapper'
import { useWrapperStore } from '../../../store/storeWrapper'
import { RecordListOrderOption } from '../../../swagger/dto'
import { DateFilter } from './components/DateFilter'
import { DateFilterRecord } from './records.constants'

export const RecordPage = () => {
    const { projectListFull } = useWrapperStore((state) => state)

    return (
        <BlockWrapper>
            <Stack
                sx={{
                    height: '100%',
                }}>
                <HeaderWrapper>
                    <Typography
                        variant="Header3"
                        sx={{
                            color: '#1B1C1D'
                        }}>
                        Записи встреч
                    </Typography>
                    <TitleWrapper>
                        {projectListFull && (
                            <>
                                <DateFilter
                                    filters={DateFilterRecord}
                                    defaultFilter={RecordListOrderOption.CreatedAt}
                                />
                                <MeetsFilter projectList={projectListFull} />
                            </>
                        )}
                    </TitleWrapper>
                </HeaderWrapper>
                <Records recordPage={true} />
            </Stack>
        </BlockWrapper>
    )
}
